import React from 'react';
import {IReduxFormSelect} from '../../../models/IReduxFormHandlers';
import ReduxFormErrorHandler from './ReduxFormErrorHandler';
import { formatMessage } from '../../../translations/connectedIntlProvider';

const ReduxFormSelect:React.FC<IReduxFormSelect> = props => {
  const errorClass = `${(props.meta.error && props.meta.touched) || props.meta.warning ? 'error' : ''}`;
  return (
    <React.Fragment>
      <select
        className={props.className + ' ' + errorClass}   
        {...props.input}
        disabled={props.disabled}
      >
        {props.options &&
        props.options.map((data: any, i: number) => {
            return <option key={i} value={data.id}>{props?.isFormatMessage ? formatMessage(data.value) : data.value}</option>;
        })}
      </select>
      <ReduxFormErrorHandler meta={props.meta}/>
    </React.Fragment>
  );
};

export default ReduxFormSelect;
